// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__ssMKj","title":"Images45_title__H-9y5","images":"Images45_images__DLdPV"};